module.exports = __webpack_public_path__ + "static/media/customize.7303c5b2.svg";